import React, { useState, useEffect, useRef, useContext } from "react"
import Loader from "react-loader-spinner"
import axios from "axios"
import * as lookup from "../../static/lookup.json"
import { LoaderContext } from "../components/context/loaderContext"

export default function Loader1() {
  const loaderContext = useContext(LoaderContext)
  const [localShowLoader, setLocalShowLoader] = useState(false)
  const showLoader = loaderContext ? loaderContext[0] : localShowLoader
  const setShowLoader = loaderContext ? loaderContext[1] : setLocalShowLoader
  const requestCounter = useRef(0)

  useEffect(() => {
    // Request Interceptor
    const requestInterceptor = axios.interceptors.request.use(
      config => {
        // use config instead of response, but no structure changes requested
        const shouldSkipLoading = lookup.skipLoadingForAPIs.some(api =>
          config.url.endsWith(api)
        );
        config.metadata = {
          ...(config.metadata || {}),
          trackLoader: !shouldSkipLoading,
        }
        if (shouldSkipLoading) {
          // skip loader for these
        } else {
          requestCounter.current++
          setShowLoader(true)
        }
        return config
      },
      error => {
        const shouldTrackLoader = error?.config?.metadata?.trackLoader
        if (shouldTrackLoader && requestCounter.current > 0) requestCounter.current--
        if (shouldTrackLoader) {
          if (requestCounter.current === 0) setShowLoader(false)
        }
        return Promise.reject(error)
      }
    )

    // Response Interceptor
    const responseInterceptor = axios.interceptors.response.use(
      response => {
        const shouldTrackLoader = response?.config?.metadata?.trackLoader
        if (shouldTrackLoader && requestCounter.current > 0) requestCounter.current--
        if (shouldTrackLoader) {
          if (requestCounter.current === 0) setShowLoader(false)
        }
        return response
      },
      error => {
        const shouldTrackLoader = error?.config?.metadata?.trackLoader
        if (shouldTrackLoader && requestCounter.current > 0) requestCounter.current--
        if (shouldTrackLoader) {
          if (requestCounter.current === 0) setShowLoader(false)
        }
        return Promise.reject(error)
      }
    )

    return () => {
      axios.interceptors.request.eject(requestInterceptor)
      axios.interceptors.response.eject(responseInterceptor)
    }
  }, [])

  return (
    <>
      {showLoader ? (
        <div
          style={{
            height: "100vh",
            width: "100%",
            background: "#80808061",
            position: "fixed",
            zIndex: "999999999999",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Loader
            type="Grid"
            color="var(--lumiq-secondary2)"
            height={100}
            width={100}
            visible={showLoader}
          />
        </div>
      ) : null}
    </>
  )
}
